import { call, put, takeEvery } from 'redux-saga/effects'
import { fetchRequest, fetchResponse } from './actions'

import nautilusApi from '../../nautilusApi'

export function * handleFetchRequest(action) {
  const { path, ...options } = action.payload
  const { ns } = action.meta

  yield put(fetchResponse(ns, undefined))

  try {
    const data = yield call(nautilusApi.fetch, path, options)
    yield put(fetchResponse(ns, data))
  } catch (error) {
    yield put(fetchResponse(ns, error))
  }
}

export default function * saga() {
  yield takeEvery(fetchRequest, handleFetchRequest)
}
